const timeFormatter = new Intl.DateTimeFormat(undefined, {
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
});

const noteTimestampFormatter = new Intl.DateTimeFormat(undefined, {
  month: 'short',
  day: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
});

const pad2 = (value: number) => String(value).padStart(2, '0');

export const formatTimestamp = (value?: string | number | Date): string => {
  if (!value) return '—';

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? '—' : timeFormatter.format(value);
  }

  const date = new Date(value);
  if (!Number.isNaN(date.getTime())) {
    return timeFormatter.format(date);
  }

  return String(value);
};

export const formatUtcDateTime = (value?: string | number | Date): string => {
  if (!value) return '—';

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);

  const day = pad2(date.getDate());
  const month = pad2(date.getMonth() + 1);
  const year = pad2(date.getFullYear() % 100);
  const hours = pad2(date.getHours());
  const minutes = pad2(date.getMinutes());
  const seconds = pad2(date.getSeconds());

  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
};

export const formatNoteTimestamp = (value?: string | number | Date): string => {
  if (!value) return '—';

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);

  return noteTimestampFormatter.format(date);
};

export const splitSpeaker = (text: string) => {
  const match = text.match(/^([A-Z][A-Z0-9\s.'-]{2,}):\s*(.*)$/);
  if (!match) {
    return { speaker: undefined, content: text };
  }

  return {
    speaker: match[1].trim(),
    content: match[2],
  };
};
